module.exports = __webpack_public_path__ + "static/media/nav_arrow_forward.74a41d3d.svg";